document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-df-menu-toggle]').forEach(btn=>{
    const id=btn.getAttribute('aria-controls');
    const nav=document.getElementById(id);
    if(!nav)return;

    const close=()=>{
      btn.setAttribute('aria-expanded','false');
      nav.hidden=true;
    };

    btn.addEventListener('click',()=>{
      const open=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',String(!open));
      nav.hidden=open;
    });

    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',close));

    document.addEventListener('keydown',event=>{
      if(event.key==='Escape' && btn.getAttribute('aria-expanded')==='true'){
        close();
        btn.focus();
      }
    });
  });
});
